import React, {useState} from 'react';
import cn from 'classnames';
import {isEmpty} from 'lodash';

import ArrowForSelect from 'shared/ui/icons/ArrowForSelect';
import Copying from 'shared/ui/icons/Copying';
import {useCopyToClipboard} from 'shared/lib/hooks/useCopyToClipboard';
import {ILastResult} from 'features/http/model/HttpMonitor/ILastResult';
import {IStatusStyles, getStatusColor, getStatusIcon} from 'entities/location';
import {isTranslate} from 'shared/lib/lang';

import {t} from '@lingui/core/macro';

import styles from './HttpIncidentModalRow.module.scss';

interface IHttpIncidentModalRowProps {
    item: ILastResult,
}

const HttpIncidentModalRow: React.FC<IHttpIncidentModalRowProps> = ({item}) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const { copy } = useCopyToClipboard();

    const statusStyles: IStatusStyles = {
        successColor: styles.successColor,
        errorColor: styles.errorColor,
        unknownColor: styles.unknownColor,
    };

    const copyHeaders = async(e: React.MouseEvent) => {
        e.stopPropagation();
        if (item.headers) {
            await copy(JSON.stringify(item.headers, null, 2));
        }
    };

    const toggleExpand = () => {
        setIsExpanded(!isExpanded);
    };

    const hasExpandableContent = item.headers && !isEmpty(item.headers) && item.status !== 'unknown';

    return (
        <>
            <div
                className={cn(styles.row, {
                    [styles.clickable]: hasExpandableContent,
                    [styles.expanded]: isExpanded,
                    [styles.enRow]: isTranslate(),
                    [styles.ruRow]: !isTranslate(),
                })}
                onClick={hasExpandableContent ? toggleExpand : undefined}
            >
                <div className={styles.cell}>{getStatusIcon(item.status)}</div>
                <div className={styles.cell}>
                    <span className={cn(styles.text, getStatusColor(item.status, statusStyles))}>
                        {item.country} / {item.name}
                    </span>
                </div>
                <div className={styles.cell}>
                    <span className={cn(styles.text, getStatusColor(item.status, statusStyles))}>
                        {item.message}
                    </span>
                </div>
                <div className={styles.cell}>
                    {hasExpandableContent && (
                        <div className={cn(styles.arrowWrapper, { [styles.rotated]: isExpanded })}>
                            <ArrowForSelect />
                        </div>
                    )}
                </div>
            </div>
            {isExpanded && hasExpandableContent && (
                <div className={styles.panel}>
                    <div className={styles.well}>
                        <div className={styles.info_block}>
                            <span>{t`Заголовки ответа`}</span>
                            <div className={styles.copyContainer}>
                                <button
                                    className={styles.copyButton}
                                    onClick={copyHeaders}
                                    aria-label={t`Копировать заголовки`}
                                    type="button"
                                >
                                    <Copying />
                                </button>
                            </div>
                        </div>
                        <pre className={styles.pre}>
                            {JSON.stringify(item.headers, null, 2)}
                        </pre>
                    </div>
                </div>
            )}
        </>
    );
};

export default HttpIncidentModalRow;
